import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../../schema-validator";

const startAssessmentEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("session"),
		name: Type.Literal("start quiz"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
		}),
	}),
);

const endAssessmentEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("session"),
		name: Type.Literal("end quiz"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
		}),
	}),
);

const endProctoringEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("session"),
		name: Type.Literal("end proctoring"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
		}),
	}),
);

export default {
	startAssessmentEvent,
	endAssessmentEvent,
	endProctoringEvent,
};
